<template>
    <div class="Orderconfirm-page">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>Thank you for your order!</h1>
                    <p>
                        Confirmation number:
                        <span v-if="order_id" v-text="order_id"></span>
                    </p>
                    <p>
                        You will receive a confirmation email soon. <br />You
                        can view the order details from your account dashboard.
                    </p>
                    <router-link to="/account" class="mayaccount-btn"
                        >My account</router-link
                    >
                    <router-link to="/" class="backTohome"
                        >Back to homepage</router-link
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
window.bvCallback = function(BV) {
    let products = [];
    for (let i = 0; i < order.order_trans.length; i++) {
        const element = order.order_trans[i];
        products.push({
            name: element.product_name,
            price: element.item_sell_price,
            quantity: "1",
            productId: element.id,
            discount: "0"
        });
    }
    BV.pixel.trackTransaction({
        orderId: "{{order.order.id}}", // provided by your system
        currency: "USD",
        total: "{{order.order.total_amt}}", // subtotal without tax, shipping, discounts
        tax: "0",
        shipping: "0",
        discount: "{{order.order.discount_amt}}", // discounts applied to total cart
        items: products,
        email: "{{ order.order.email }}",
        locale: "en_US",
        nickname: "{{order.order.first_name}}" // used for email personalization
    });
};
export default {
    name: "thankyou",
    props: ["order"],
    data() {
        return {
            order_id: ""
        };
    },
    beforeMount() {
        console.log("this.order", this.order.order);
        window.bvCallback = function(BV) {
            let products = [];
            for (let i = 0; i < order.order_trans.length; i++) {
                const element = order.order_trans[i];
                products.push({
                    name: element.product_name,
                    price: element.item_sell_price,
                    quantity: "1",
                    productId: element.id,
                    discount: "0"
                });
            }
            BV.pixel.trackTransaction({
                orderId: "{{order.order.id}}", // provided by your system
                currency: "USD",
                total: "{{order.order.total_amt}}", // subtotal without tax, shipping, discounts
                tax: "0",
                shipping: "0",
                discount: "{{order.order.discount_amt}}", // discounts applied to total cart
                items: products,
                email: "{{ order.order.email }}",
                locale: "en_US",
                nickname: "{{order.order.first_name}}" // used for email personalization
            });
        };
        if (
            (!this.order.order ||
                !this.order.order.id ||
                typeof this.order.order === "undefined") &&
            !this.$route.query.od
        ) {
            this.$router.push("/account").catch({});
        } else {
            console.log("this.order", this.order);
            this.order_id = this.$route.query.od
                ? this.$route.query.od
                : this.order.order.id;
        }
    }
};
</script>
